import { Navigate, useLocation } from 'react-router-dom';
import { useSupportAuth } from '@/context/SupportAuthContext';

export function RequireAgent({ children, adminOnly = false }: { children: React.ReactNode; adminOnly?: boolean }) {
  const { user, agent, admin, loading, configured } = useSupportAuth();
  const location = useLocation();

  if (!configured) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 text-center">
        <p className="text-sm text-muted-foreground">
          Firebase is not configured. Add VITE_FIREBASE_* keys - see docs/HUMAN_SUPPORT_SETUP.md.
        </p>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!user || user.isAnonymous) {
    return <Navigate to="/support/login" replace state={{ from: location.pathname + location.search }} />;
  }

  if (adminOnly && !admin) {
    return <Navigate to="/support/dashboard" replace />;
  }

  if (!admin && !agent?.active) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6 text-center">
        <p className="text-sm text-muted-foreground">
          Your account is not an active support agent. Contact an admin.
        </p>
      </div>
    );
  }

  return <>{children}</>;
}
